import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";

import SidebarStudent from "./Utils/SidebarStudent";
import CreateGuardian, { GuardianFormRef } from "./Resource/CreateGuardian";

import "./Dashboard.css";
import "./ParentDetails.css";
import { logout } from "../apis/backend";
import { toast } from "../utils/toast";

import { useStudentProgress } from "../context/StudentProgressContext";
import LogoutButton from "./LogoutButton";

export default function ParentDetails() {
  const navigate = useNavigate();
  const { refreshProgress } = useStudentProgress(); // ✅ Get refresh function

  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);

  const [isSaving, setIsSaving] = useState(false);

  const guardianRef = useRef<GuardianFormRef>(null);

  const handleSaveAndNext = async () => {
    try {
      setIsSaving(true);
      if (guardianRef.current) {
        await guardianRef.current.save();

        const gErrors = guardianRef.current.getErrors();
        if (Object.keys(gErrors).length > 0) {
          toast.error("Please complete all required fields.");
          return;
        }

        // ✅ Trigger progress update after successful save
        await refreshProgress();

        toast.success("Parent/Guardian details saved successfully!");

        setTimeout(() => navigate("/educationdetails"), 1000);
      }
    } catch (error) {
      console.error("Error saving details:", error);
      toast.error("Error saving details. Please try again.");
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="dash-layout">
      {/* Sidebar */}
      <SidebarStudent
        sidebarCollapsed={sidebarCollapsed}
        toggleSidebar={() => setSidebarCollapsed((p) => !p)}
      />

      {/* Main Wrapper */}
      <div
        className={`dash-wrapper ${sidebarCollapsed ? "dash-wrapper-collapsed" : ""
          }`}
      >
        {/* Header */}
        <header className="dash-header">
          <h1 className="dash-page-title">Parent & Guardians Details</h1>

          <div className="dash-user-profile">
            <div
              className="dash-profile-circle"
              onClick={() => setShowDropdown((p) => !p)}
            >
              <span>S</span>
            </div>

            {showDropdown && (
              <div className="dash-profile-dropdown">
                <LogoutButton />
              </div>
            )}
          </div>
        </header>

        {/* Page Content */}
        <div className="dash-content-body">
          {/* Guardian Form */}
          <CreateGuardian ref={guardianRef} />

          {/* Save & Next Buttons */}
          {/* Save & Next Buttons */}
          <div className="form-actions gap-2">
            <button
              className="save-btn"
              type="button"
              onClick={handleSaveAndNext}
              disabled={isSaving}
              style={{ background: "#28a745" }}
            >
              {isSaving ? "Saving..." : "Save & Next"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
